import axios from "axios";

const API = "/api";
const auth = () => ({ headers: { Authorization: `Bearer ${localStorage.getItem("token")}` } });

export async function carregarConfig() {
  const { data } = await axios.get(`${API}/campaigns/sales-recovery/config`, auth());
  return data;
}

export async function salvarConfig(corpo) {
  const { data } = await axios.put(`${API}/campaigns/sales-recovery/config`, corpo, auth());
  return data;
}

export async function gerarPrevia(corpo) {
  const { data } = await axios.post(`${API}/campaigns/sales-recovery/preview`, corpo, auth());
  return data;
}

export async function carregarRelatorio({ inicio, fim }) {
  const { data } = await axios.get(`${API}/campaigns/sales-recovery/report`, {
    ...auth(), params: { date_from: inicio, date_to: fim },
  });
  return data;
}
